/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "adsb_regulatory_manager";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AirspaceVolume {
}

export enum AirspaceVolume_Enum {
  NONE = 0,
  FILTER = 1,
  ALERT = 2,
  SD_BUFFER = 3,
  SD = 4,
  NMAC_BUFFER = 5,
  NMAC = 6,
  UNRECOGNIZED = -1,
}

export function airspaceVolume_EnumFromJSON(object: any): AirspaceVolume_Enum {
  switch (object) {
    case 0:
    case "NONE":
      return AirspaceVolume_Enum.NONE;
    case 1:
    case "FILTER":
      return AirspaceVolume_Enum.FILTER;
    case 2:
    case "ALERT":
      return AirspaceVolume_Enum.ALERT;
    case 3:
    case "SD_BUFFER":
      return AirspaceVolume_Enum.SD_BUFFER;
    case 4:
    case "SD":
      return AirspaceVolume_Enum.SD;
    case 5:
    case "NMAC_BUFFER":
      return AirspaceVolume_Enum.NMAC_BUFFER;
    case 6:
    case "NMAC":
      return AirspaceVolume_Enum.NMAC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AirspaceVolume_Enum.UNRECOGNIZED;
  }
}

export function airspaceVolume_EnumToJSON(object: AirspaceVolume_Enum): string {
  switch (object) {
    case AirspaceVolume_Enum.NONE:
      return "NONE";
    case AirspaceVolume_Enum.FILTER:
      return "FILTER";
    case AirspaceVolume_Enum.ALERT:
      return "ALERT";
    case AirspaceVolume_Enum.SD_BUFFER:
      return "SD_BUFFER";
    case AirspaceVolume_Enum.SD:
      return "SD";
    case AirspaceVolume_Enum.NMAC_BUFFER:
      return "NMAC_BUFFER";
    case AirspaceVolume_Enum.NMAC:
      return "NMAC";
    case AirspaceVolume_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAirspaceVolume(): AirspaceVolume {
  return {};
}

export const AirspaceVolume = {
  encode(_: AirspaceVolume, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AirspaceVolume {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirspaceVolume();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AirspaceVolume {
    return {};
  },

  toJSON(_: AirspaceVolume): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AirspaceVolume>, I>>(base?: I): AirspaceVolume {
    return AirspaceVolume.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AirspaceVolume>, I>>(_: I): AirspaceVolume {
    const message = createBaseAirspaceVolume();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
